import { render, staticRenderFns } from "./cbjl.vue?vue&type=template&id=29dcab98&scoped=true&"
import script from "./cbjl.vue?vue&type=script&lang=js&"
export * from "./cbjl.vue?vue&type=script&lang=js&"
import style0 from "./cbjl.vue?vue&type=style&index=0&id=29dcab98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dcab98",
  null
  
)

export default component.exports